module.exports = __webpack_public_path__ + "static/img/wapLogo.a1b8b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/wapLogo.png
// module id = c8zS
// module chunks = 0